__turbopack_context__.v({
  "center": "divs-module-sass-module__tQcecq__center",
  "flex12": "divs-module-sass-module__tQcecq__flex12",
  "flex16": "divs-module-sass-module__tQcecq__flex16",
  "flex20": "divs-module-sass-module__tQcecq__flex20",
  "flex24": "divs-module-sass-module__tQcecq__flex24",
  "flex28": "divs-module-sass-module__tQcecq__flex28",
  "flex32": "divs-module-sass-module__tQcecq__flex32",
  "flex36": "divs-module-sass-module__tQcecq__flex36",
  "flex4": "divs-module-sass-module__tQcecq__flex4",
  "flex40": "divs-module-sass-module__tQcecq__flex40",
  "flex44": "divs-module-sass-module__tQcecq__flex44",
  "flex48": "divs-module-sass-module__tQcecq__flex48",
  "flex52": "divs-module-sass-module__tQcecq__flex52",
  "flex56": "divs-module-sass-module__tQcecq__flex56",
  "flex60": "divs-module-sass-module__tQcecq__flex60",
  "flex64": "divs-module-sass-module__tQcecq__flex64",
  "flex8": "divs-module-sass-module__tQcecq__flex8",
  "flexCl12": "divs-module-sass-module__tQcecq__flexCl12",
  "flexCl16": "divs-module-sass-module__tQcecq__flexCl16",
  "flexCl20": "divs-module-sass-module__tQcecq__flexCl20",
  "flexCl24": "divs-module-sass-module__tQcecq__flexCl24",
  "flexCl28": "divs-module-sass-module__tQcecq__flexCl28",
  "flexCl32": "divs-module-sass-module__tQcecq__flexCl32",
  "flexCl36": "divs-module-sass-module__tQcecq__flexCl36",
  "flexCl4": "divs-module-sass-module__tQcecq__flexCl4",
  "flexCl40": "divs-module-sass-module__tQcecq__flexCl40",
  "flexCl44": "divs-module-sass-module__tQcecq__flexCl44",
  "flexCl48": "divs-module-sass-module__tQcecq__flexCl48",
  "flexCl52": "divs-module-sass-module__tQcecq__flexCl52",
  "flexCl56": "divs-module-sass-module__tQcecq__flexCl56",
  "flexCl60": "divs-module-sass-module__tQcecq__flexCl60",
  "flexCl64": "divs-module-sass-module__tQcecq__flexCl64",
  "flexCl8": "divs-module-sass-module__tQcecq__flexCl8",
});
